import { IBaseServicesArray, ITitleDescription } from "../Interfaces/base";
import { IOpportunitiesSection, ITopBanner, IYoutubeVideo } from "../Interfaces/shared";


const platformIcon: string = require("../assets/images/services/efficient-platform-icon.svg").default;
const supportIcon: string = require("../assets/images/services/support-center-icon.svg").default;
const ratingIcon: string = require("../assets/images/services/rating-icon.svg").default;
const notaryIcon: string = require("../assets/images/services/notary-icon.svg").default;
const sectionImage: string = require("../assets/images/notary-section-image.png").default;
const bannerImageDesktop: string = require("../assets/images/notary-banner.jpg").default;
const bannerImageMobile: string = require("../assets/images/notary-banner-mobile.png").default;


export const seo: ITitleDescription = {
  title: 'Remote notary services for auto transactions | Mavsign',
  description: 'Join our nationwide certified mobile notary network for auto deals! We provide a steady flow of clients based on your proximity to them. We\'ve got you covered. ',
}

export const topBanner: ITopBanner = {
  title: 'Join our network',
  image: {
    mobile: bannerImageMobile,
    desktop: bannerImageDesktop,
  },
  eventAction: 'request_demo_event_notaries',
  eventLabel: 'Request Demo Button - For Notaries',
  altText: 'Traveling notary meeting remote client for car documents signing',
  description: 'The notaries in Mavsign’s nationwide signing service are a vital component of the company’s trusted services. They are the dealership’s collaborators that bring the human touch in the final steps of the transaction: closing the deal by signing the car purchase contracts. Their role is invaluable: they keep the order on track and expedite the entire process by meeting with the customers and not allowing delaying tactics or other factors to delay the signing.</br>' +
    'As part of the nation’s premier certified notary service, you will be acting as both Mavsign’s and the dealer’s representative in client meetings. The accuracy of document signing and completion will be your top priority. Your keen eye will be the first to notice any discrepancies that may lead to fraudulent attempts. In such instances, the Mavsign team is constantly prepared to offer support or assistance.</br>' +
    'If you are an experienced notary and would like to partner with Mavsign and our nationwide clients, register below and join the Mavsign Signings team!'
}

export const opportunitiesSection: IOpportunitiesSection = {
  title: 'Why join the Mavsign mobile team',
  image: sectionImage,
  altText: 'Phone screen showing remote notary proximity to remote auto client'
}

export const services: IBaseServicesArray[] = [
  {
    icon: {
      src: platformIcon
    },
    title: 'Efficient Platform',
    description: ['<p>Easily manage and track your Orders. All the documents you need at your fingertips.</p>']
  },
  { 
    icon: {
      src:supportIcon
    },
    title: 'Assistance',
    description: ['<p>Receive support whenever you need it.\n' +
    'Your observations on potential Red Flags will be escalated to our specialized Fraud Team.</p>']
  },
  { 
    icon: {
      src: ratingIcon
    },
    title: 'Better Earnings',
    description: ['<p>Increase your income with Mavsign’s growing opportunities.\n' +
    'Our schedulers will assign customers based on your proximity to them.</p>']
  },
  { 
    icon: {
      src: notaryIcon
    },
    title: 'Experience',
    description: ['<p>Sharpen your notary skills in the automotive signing industry.\n' +
    'Work with the nation’s leader in offsite car contract signings.</p>']
  },
];

export const youtubeVideo: IYoutubeVideo = {
  url: 'https://www.youtube.com/embed/PbHmV0z6I64?si=G2WJR2D1dm_xWgzs&rel=0',
  eventAction: 'youtube_video_event_notaries',
  eventLabel: 'Youtube Video - For Notaries',
}